import { CountryCode } from './countries';
import { getPhoneUtil } from './getPhoneUtil';

/**
 * Check if a phone number is valid for a given country code.
 */
export const isValidPhoneNumber = (
  phoneNumber: string | undefined,
  countryCode: CountryCode
): phoneNumber is string => {
  // if phoneNumber is empty, consider it valid: user didn't type anything yet
  if (!phoneNumber) {
    return true;
  }

  const phoneUtil = getPhoneUtil();

  try {
    const number = phoneUtil.parse(phoneNumber, countryCode);
    return phoneUtil.isValidNumberForRegion(number, countryCode);
  } catch {
    return false;
  }
};
